import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=48ea71d4&"
import script from "./BaseFilter.vue?vue&type=script&lang=js&"
export * from "./BaseFilter.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports